import TabSet from './component.styles'
export default TabSet
